/**
 *
 * Styles for ModalFreightP2P
 *
 */

import styled from "styled-components";
import { DhlText } from "@dhl-official/react-library";
import { FormField } from "root/libs/ui-components/src";
import { breakpoints } from "root/libs/ui-styleguide/src";

const formFieldBottomSpacing = "10px";

export const OfferSummary = styled.section`
  border-top: var(--dui-size-width-border-xs) solid var(--dui-color-gray-600);
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: var(--gaq-size-space-30px) var(--dui-size-space-5x)
    var(--dui-size-space-0) var(--dui-size-space-5x);
  box-sizing: border-box;

  @media screen and (min-width: ${breakpoints.tablet}) {
    flex-direction: row;
    padding: var(--gaq-size-space-30px) 0 var(--dui-size-space-10x);
  }
`;
export const PriceArea = styled.div`
  display: flex;
  margin-top: var(--gaq-size-space-5px);
  margin-bottom: var(--gaq-size-space-30px);

  @media screen and (min-width: ${breakpoints.tablet}) {
    margin: 0;
    padding-right: var(--dui-size-space-5x);
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    width: 18%;
  }

  .price {
    font-size: var(--dui-size-font-3xl);
    line-height: var(--dui-size-line-height-10xl);
    font-weight: 900;

    @media screen and (min-width: ${breakpoints.tablet}) {
      font-size: var(--dui-size-font-md);
      line-height: var(--dui-size-line-height-lg);
    }
  }

  dd,
  dl {
    margin: 0;
  }

  dt {
    display: inline-block;
    padding-right: var(--dui-size-space-5x);

    @media screen and (min-width: ${breakpoints.tablet}) {
      font-size: var(--dui-size-font-xs);
    }

    @media screen and (min-width: ${breakpoints.desktop}) {
      display: block;
    }
  }

  dd {
    display: inline-block;
  }
`;
export const QuotationOfferArea = styled.div`
  display: flex;
  margin-bottom: var(--dui-size-space-5x);

  span {
    margin-right: var(--dui-size-space-8x);

    svg {
      position: absolute;
      align-self: center;
    }

    @media screen and (min-width: ${breakpoints.tablet}) {
      margin-right: var(--dui-size-space-5x);
    }
  }

  .quotationId {
    font-size: var(--dui-size-font-3xl);
    line-height: var(--dui-size-line-height-10xl);
    font-weight: 900;

    @media screen and (min-width: ${breakpoints.tablet}) {
      font-size: var(--dui-size-font-md);
      line-height: var(--dui-size-line-height-lg);
    }
  }

  dt::after {
    content: ": ";
  }

  dl,
  dd {
    margin: 0;
  }

  @media screen and (min-width: ${breakpoints.tablet}) {
    width: calc(100% / 1.5);
    padding-right: var(--dui-size-space-10x);
    align-self: flex-start;
  }

  &.offerSummary {
    flex-direction: column;

    @media screen and (min-width: ${breakpoints.tablet}) {
      order: 3;
      padding-right: 0;
    }

    @media screen and (min-width: ${breakpoints.desktop}) {
      width: 50%;
    }

    h5 {
      margin-bottom: var(--dui-size-space-2x);
    }

    dt,
    dd {
      display: inline;
      font-size: var(--dui-size-font-xs);
      line-height: var(--dui-size-line-height-normal);
    }

    dt {
      padding-right: var(--dui-size-space-2x);
    }
  }
`;
export const FormWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  max-width: 620px;
  margin: 0 auto;
`;
export const StyledFieldset = styled.fieldset`
  width: 100%;
  box-sizing: border-box;

  .textNote {
    text-align: center;
  }

  @media screen and (min-width: ${breakpoints.tablet}) {
    padding: 0;
  }
`;
export const Wrapper = styled.div`
  width: 100%;

  & > p {
    padding: 0 var(--dui-size-space-10x);
    padding-bottom: var(--dui-size-space-5x);
  }

  .button-wrapper {
    padding: 0 var(--dui-size-space-5x);
    margin: var(--dui-size-space-10x) auto;
  }
`;
export const FieldsetLegend = styled.legend`
  width: 100%;
  max-width: 460px;
  margin: 0 auto;
  margin-bottom: var(--gaq-size-space-30px);

  h4 {
    margin-bottom: 0;
  }
`;

export const FormFieldWrapper = styled(FormField)`
  display: block;
  margin-bottom: ${formFieldBottomSpacing};

  & > div > dhl-validation-feedback {
    margin-top: 0;
  }

  & + dhl-validation-feedback {
    margin-bottom: ${formFieldBottomSpacing};
  }
`;

export const StyledContainer = styled.div`
  display: block;
  width: 100%;

  @media screen and (min-width: ${breakpoints.tablet}) {
    width: 50%;
    padding-left: var(--gaq-size-space-13px);
    padding-right: 0;
    box-sizing: border-box;

    &:first-of-type {
      padding-right: var(--gaq-size-space-13px);
      padding-left: 0;
    }
  }
`;
export const TermsAndConditionsText = styled(DhlText)`
  & > *:is(p, span) {
    text-align: center;
    max-width: 620px;
    margin: 0 auto;
  }
`;
